import axios from 'axios'
import { toast } from 'react-toastify'
import { handleLogout } from 'src/services/logout/logout'
import { apiRequest, msalInstance } from 'src/config/msalConfig'
import { getBaseUrl } from 'src/store/useEnvironmentStore'
import { loginPathForCurrentEnv } from 'src/config/environments'

// export const clearApplicationData = async () => {
//   try {
//     localStorage.clear()
//     window.location.href = routes.login
//   } catch (e) {
//     console.error(e)
//   }
// }

const axiosClient = axios.create({
  baseURL: getBaseUrl(),
})

const getAzureAccessToken = async () => {
  try {
    const activeAccount = msalInstance.getActiveAccount()
    if (!activeAccount) return null

    const response = await msalInstance.acquireTokenSilent({
      scopes: apiRequest.scopes,
      account: activeAccount,
    })

    return response.accessToken
  } catch (error) {
    console.error('Error getting Azure access token:', error)
    return null
  }
}

axiosClient.interceptors.request.use(
  async (config) => {
    // Get Azure access token for authentication
    const azureAccessToken = await getAzureAccessToken()

    if (azureAccessToken) {
      config.headers.Authorization = `Bearer ${azureAccessToken}`
    } else {
      console.warn('No Azure access token available for request')
    }
    return config
  },
  async (error) => {
    return Promise.reject(error)
  }
)

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })

  failedQueue = []
}
axiosClient.interceptors.response.use(
  (res) => {
    return res
  },
  async (err) => {
    const originalRequest = err.config

    if (err.response?.status === 403 && err.response?.data?.detail === 'User does not exist') {
      toast.error('User does not exist. Please login again.')
      await handleLogout()
      return await Promise.reject(err)
    }
    if ([401, 403].includes(err.response?.status) && !originalRequest._retry) {
      if (isRefreshing) {
        return await new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject })
        })
          .then(async (token) => {
            originalRequest.headers.Authorization = `Bearer ${token}`
            return await axios(originalRequest)
          })
          .catch(async (err) => {
            return await Promise.reject(err)
          })
      }

      originalRequest._retry = true
      isRefreshing = true

      return await new Promise(function (resolve, reject) {
        // Try to get a fresh Azure access token
        getAzureAccessToken()
          .then((azureToken) => {
            if (azureToken) {
              originalRequest.headers.Authorization = `Bearer ${azureToken}`
              processQueue(null, azureToken)
              resolve(axios(originalRequest))
            } else {
              // No valid Azure token available, user needs to login again
              processQueue(new Error('Authentication required'), null)
              toast.error('Session expired. Please login again.')
              handleLogout()
              // Redirect to login page
              window.location.href = loginPathForCurrentEnv()
              reject(new Error('Authentication required'))
            }
          })
          .catch((azureErr) => {
            console.error('Error refreshing Azure token:', azureErr)
            processQueue(azureErr, null)
            toast.error('Session expired. Please login again.')
            handleLogout()
            // Redirect to login page
            window.location.href = loginPathForCurrentEnv()
            reject(azureErr)
          })
          .finally(() => {
            isRefreshing = false
          })
      })

     
    }

    return await Promise.reject(err)
  }
)

export { axiosClient }
